import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from '../messages';

export const RestrictedShipmentBannerMessage = () => (
  <BannerMessageV2 content={<Text textType={TextType.Caption} value={messages.emptyShipmentConfigMessage} />} status={BannerStatus.Info} />
);
